module.exports = __webpack_public_path__ + "static/media/k.73eaf8c2.png";